<template>
  <div id="apps">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('APPLICATION', 2) }) | formatTitle" />
    <application-list />

    <router-view class="ui applications__route" />
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

#apps {
  padding-left: 20px;
}

.applications__route {
  height: 100%;
}
</style>

<script>
// @flow
import ApplicationList from './ApplicationList'

export default {
  name: 'applications',
  components: { ApplicationList }
}
</script>
